import logo from '../logo.svg'
import './SignIn.scss'
import { useHistory } from 'react-router-dom'
import { Form, Input, Button, Modal, Card } from 'antd'
import { accountPayload } from '../reducers/account/accountAPI'
import md5 from 'js-md5'
import { useAppDispatch } from '../app/hooks'
import {
  feachAccountAsync,
  feachAccountByTokenAsync,
  restore,
  restoreUser
} from '../reducers/account/accountSlice'
import ReCAPTCHA from 'react-google-recaptcha'
import { useState, useEffect, useRef } from 'react'
import axios from 'axios'

const SignIn = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const recaptchaRef = useRef<any>()
  const [loading, setLoading] = useState(false)
  const [siteKey, setSiteKey] = useState(process.env.REACT_APP_RECAPTCHA_SITE_KEY || '')

  useEffect(() => {
    let cancelled = false
    axios.get('/api/public/config')
      .then((res) => {
        const key = res?.data?.data?.siteKey || res?.data?.siteKey || ''
        if (!cancelled && key) {
          setSiteKey(key)
        }
      })
      .catch(() => {
        // keep build-time key fallback if any
      })
    return () => { cancelled = true }
  }, [])

  const onFinish = async () => {
    const values = form.getFieldsValue()
    values.password = md5(values.password)
    const recaptchaValue = recaptchaRef.current?.getValue()
    if (siteKey && !recaptchaValue) {
      Modal.error({
        title: 'Error',
        content: 'Please complete captcha!',
      })
      return
    }
    values['g-recaptcha-response'] = recaptchaValue
    setLoading(true)
    const result = await dispatch(feachAccountAsync({
      ...values
    } as accountPayload))
    setLoading(false)
    const { payload } = result
    if (payload) {
      const { data, code, msg } = payload
      if (code === 0) {
        data.tokenExpiredAt = new Date(data.tokenExpiredAt)
        dispatch(restore({
          token: data.token,
          tokenExpiredAt: data.tokenExpiredAt.toString()
        }))
        dispatch(restoreUser({ user: data.user }))
        localStorage.setItem('token', data.token)
        localStorage.setItem('tokenExpiredAt', data.tokenExpiredAt.getTime())
        if (data.user.type === 'admin') {
          return history.push('/admin')
        }
        history.push('/work/all')
      } else if (msg) {
        recaptchaRef.current?.reset()
        Modal.error({
          title: 'Error',
          content: msg,
        })
      }
    }
    if (typeof payload === 'string') {
      recaptchaRef.current?.reset()
      Modal.error({
        title: 'Error',
        content: payload
      })
    }
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  const signInByToken = async () => {
    const token = localStorage.getItem('token')
    if (token) {
      const result = await dispatch(feachAccountByTokenAsync({}))
      const { payload } = result
      if (payload) {
        const { data, code } = payload
        if (code === 0) {
          dispatch(restore({
            token: data.token,
            tokenExpiredAt: data.tokenExpiredAt.toString()
          }))
          dispatch(restoreUser({ user: data.user }))
          if (data.user.type === 'admin') {
            history.push('/admin')
          } else {
            history.push('/work/all')
          }
        }
      }
    }
  }

  useEffect(() => {
    signInByToken()
  }, [])

  return (
    <Card hoverable style={{ width: 650, margin: '100px auto 0' }}>
      <Form
        className="sign-form"
        form={form}
        name="basic"
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="logo-box">
          <img src={logo} className="App-logo" alt="logo" />
        </div>
        <Form.Item
          className="sign-input"
          label="Username"
          name="mobile"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          className="sign-input"
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password />
        </Form.Item>
        {siteKey ? (
          <Form.Item
            className="sign-input sign-captch"
            label="Captcha"
            rules={[{ required: true, message: 'Please complete captcha!' }]}
          >
            <ReCAPTCHA
              sitekey={siteKey}
              ref={recaptchaRef}
            />
          </Form.Item>
        ) : null}
        <Form.Item wrapperCol={{ offset: 7, span: 16 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            Login
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default SignIn
